export default "__VITE_ASSET__JNBwhWgb__"